import React, { useEffect, useState } from "react";
import YourGuidePageData from "./YourGuidePageData";
import YourGuidePageNoData from "./YourGuidePageNoData";
import WebUtils from "../../../../utils/WebUtils";
import { getJobGuidesApi } from "../../../../api/candidate";
import Utils from "../../../../utils/Utils";
import Loader from "../../../Loader";
import { Card, Skeleton } from "antd";

const userDetail = Utils.getUserDetail();
const pageSize = 6;

function YourGuidePage({
  guideDataFlag,
  setGuideDataFlag,
  preparationGuideStatus,
  jobGuideFilters,
  searchButtonText,
  clearResultsFlag,
  notFoundFlag,
  setNotFoundFlag,
  moduleInfo,
  setSelectedTab,
}) {
  const [loading, setLoading] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const getJobGuides = (pageNo, pageSize, searchInput) => {
    const url = `${getJobGuidesApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&preparationGuideStatus=${preparationGuideStatus}&jobGuideFilters=${jobGuideFilters}&pageNumber=${pageNo}&pageSize=${pageSize}&searchValue=${searchInput}&organizationId=${userDetail.organizationId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let count = result.data.data.totalCount;
          if (
            count === 0 &&
            (preparationGuideStatus === "Active" ||
              preparationGuideStatus === "Draft")
          ) {
            setNotFoundFlag(true);
          } else {
            setNotFoundFlag(false);
          }
          setGuideDataFlag(result.data.data.jobGuideResponseData);
          // setGuideDataFlag([]);
          setPageCount(count);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setNotFoundFlag(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    setCurrPage(0);
    getJobGuides(0, pageSize, searchButtonText);
  }, [jobGuideFilters, preparationGuideStatus, searchButtonText]);

  const onPageChange = (num) => {
    setCurrPage(num - 1);
    getJobGuides(num - 1, pageSize, searchButtonText);
  };

  return (
    <>
      {loading ? (
        <>
          {/* {(!searchButtonText && !clearResultsFlag) && (
            <div className="w-full flex justify-between flex-col lg:flex-row gap-4  ">
              <div className="w-full sm:w-[70%] lg:w-[40%] xl:w-[45%] flex flex-wrap gap-2">
                <span className="w-full 2xl:w-[53%] ">
                  <Skeleton.Input
                    // title
                    // paragraph={false}
                    // row={1}

                    active
                  />
                </span>
                <div className="w-full 2xl:w-[42%]  gap-2">
                  <Skeleton.Button active />
                </div>
              </div>
              <div className="flex gap-3 flex-wrap justify-end  w-full">
                <Skeleton.Button active />
                <Skeleton.Button active />
                <Skeleton.Button active />
              </div>
            </div>
          )} */}
          <div className="mt-4 flex flex-col items-center">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[1.1rem] gap-x-[1.3rem] w-full">
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
              <Card className="w-full ">
                <Skeleton active paragraph />
              </Card>
            </div>
          </div>
        </>
      ) : notFoundFlag || (guideDataFlag && guideDataFlag.length > 0) ? (
        <YourGuidePageData
          notFoundFlag={notFoundFlag}
          guideDataFlag={guideDataFlag}
          pageNumber={currPage}
          pageSize={pageSize}
          onPageChange={onPageChange}
          pageCount={pageCount}
        />
      ) : (
        !notFoundFlag &&
        (!guideDataFlag || guideDataFlag.length === 0) && (
          <YourGuidePageNoData
            setSelectedTab={setSelectedTab}
            moduleInfo={moduleInfo}
          />
        )
      )}
      {/* {guideDataFlag && guideDataFlag.length > 0 && (
        <YourGuidePageData
          guideDataFlag={guideDataFlag}
          pageNumber={currPage}
          pageSize={pageSize}
          onPageChange={onPageChange}
          pageCount={pageCount}
        />
      )}
      {(!guideDataFlag || guideDataFlag.length === 0) && (
        <YourGuidePageNoData />
      )} */}
    </>
  );
}

export default YourGuidePage;
